import formInputsTypes from 'constants/simulatorData/simulatorConstant';
import {
    axeData,
    cote_manivelle,
    createAxe,
    isWithAgraffe,
} from 'constants/simulatorDataDetails/simulatorConstant';
import { MesureLargeur } from '../rideauMetallique/data';

const MIN_WIDTH = 0;
const attaches = {
    id: 'VR-TR-AXE-W',
    type: formInputsTypes?.INPUT_NUMBER,
    name: 'attaches',
    className: 'col-6',
    label: 'Nombre Agraffe Rigide',
    defaultValue: MIN_WIDTH,
    nextStepData: false,
    nextStep: false,
    validation: (value) => {
        return value > 0;
    },
};
const sortiCaisson = {
    id: 'sortiCaisson',
    type: formInputsTypes?.RADIO_INPUT,
    label: 'Sortie de Caisson 6P7',
    name: 'sortiCaisson',
    className: 'col-6',
    nextStepData: isWithAgraffe(attaches),
    nextStep: false,
    options: [
        {
            id: '45',
            label: '45°',
            value: '45°',
            nextStep: false,
            description:
                '- Sortie de Caisson 6P7 : 45°\n\n' +
                '- Accessoires : tendeurs réglables, embouts fixes, coussinets.\n' +
                '- Manivelle : diamètre 12 mm, blanc, longueur 1500 mm.',
        },
        {
            id: '90',
            label: '90°',
            value: '90°',
            nextStep: false,
            description:
                '- Sortie de Caisson 6P7 : 90°\n\n' +
                '- Accessoires : tendeurs réglables, embouts fixes, coussinets.\n' +
                '- Manivelle : diamètre 12 mm, blanc, longueur 1500 mm.',
        },
    ],
};

const coupleConique = {
    id: 'sortiCaisson',
    type: formInputsTypes?.RADIO_INPUT,
    label: 'Couple Conique',
    name: 'coupleConique',
    className: 'col-6',
    nextStepData: sortiCaisson,
    nextStep: false,
    options: [
        {
            id: 'gris12',
            label: 'Gris 12Nm',
            value: 'Gris 12Nm',
            nextStep: false,
            description:
                '- Couple conique Gris renforcé d’une puissance de 12Nm. '
        },
        {
            id: 'noir30',
            label: 'Noir 30Nm',
            value: 'Noir 30Nm',
            nextStep: false,
            description:
                '- Couple conique Noir renforcé d’une puissance de 30Nm. '
        },
    ],
};


const ressort = {
    id: 'ressort',
    type: formInputsTypes?.RADIO_INPUT,
    label: 'Ressort',
    name: 'ressort',
    // nextStepData: isWithAgraffe,
    nextStepData: false,
    className: 'col-6',
    nextStep: false,
    fetchData: (currentFormValue, fnSuccess) => {
        const type = currentFormValue?.values?.typeInstallation?.value

        const typeproduct = currentFormValue?.values?.typeproduct?.value
        const typeInstallation = currentFormValue?.values?.typeInstallation?.value
        const getNextStep = () => {
            if (typeproduct == "Kit Manuel") return false
            if (typeInstallation == "Traditionnel" && typeproduct !== "Kit Manuel") return coupleConique
            return sortiCaisson
        }


        const getDescription = () => {
            // if (type == "Traditionnel") return ""
            // return '- Treuil Technivis 6P7 avec fins de course intégrées.'
            if (typeproduct == "Kit Manuel") {
                return
            }
        }
        const options = [
            {
                id: 'ressort-Non',
                label: 'Sans ressort',
                value: 'Sans ressort',
                nextStep: getNextStep(),
                description: getDescription(),
            },
            {
                id: 'ressort-Oui',
                label: 'Avec ressort',
                value: 'Avec ressort',

                nextStep: getNextStep(),
                description: getDescription() + '\n- Avec ressort.'
            },
        ]
        fnSuccess(options)
    },

};

const matiereOldLame = {
    id: 'matierOldLame',
    type: formInputsTypes?.RADIO_INPUT,
    label: 'Matière tablier existant',
    name: 'matiereOldLame',
    nextStepData: false,
    className: 'col-6',
    nextStep: false,

    fetchData: (currentFormValue, fnSuccess) => {
        const typeproduct = currentFormValue?.values?.typeproduct?.value;
        const typeInstallation = currentFormValue?.values?.typeInstallation?.value;

        const skipRessort = (value) => {
            if (value === "Bois") {
                if (typeproduct === "Kit Manuel") return false;
                if (typeInstallation === "Traditionnel") return coupleConique;
                return sortiCaisson;
            }
            return ressort;
        };

        const options = [
            {
                id: 'PVC',
                label: 'PVC',
                value: 'PVC',
                nextStep: ressort,
            },
            {
                id: 'Aluminium',
                label: 'Aluminium',
                value: 'Aluminium',
                nextStep: ressort,
            },
            {
                id: 'Bois',
                label: 'Bois',
                value: 'Bois',
                nextStep: skipRessort("Bois"),
            },
        ];

        fnSuccess(options);
    },
};



const largeur = {
    id: 'VR-TR-AXE-TMW',
    type: formInputsTypes?.RADIO_INPUT,
    name: 'typeMesureLargeur',
    className: 'col-6',
    label: 'Mesure selon largeur',
    nextStepData: false,
    nextStep: false,
    fetchData: (currentFormValue, fnSuccess) => {
        const largeur = currentFormValue?.values?.largeur?.value;

        const typeproduct = currentFormValue?.values?.typeproduct?.value
        const typeInstallation = currentFormValue?.values?.typeInstallation?.value
        const getNextStep = () => {
            if (typeInstallation == "Traditionnel" && typeproduct == "Kit Manuel") return cote_manivelle(matiereOldLame)
            return cote_manivelle(false)
        }

        const options = [
            {
                id: 'RMFN',
                label: 'FINI',
                value: 'FINI',
                nextStep: getNextStep(),
                description: `- Largeur : ${largeur} mm FINI`

            },
            {
                id: 'RME',
                label: 'DC',
                value: 'DC',
                nextStep: getNextStep(),
                description: `- Largeur : ${largeur} mm D.C`


            },

        ]
        fnSuccess(options);
    },
};

const AxeManuel = {
    id: 'VR-TR-AXE-W',
    type: formInputsTypes?.INPUT_NUMBER,
    name: 'largeur',
    className: 'col-6',
    label: 'Largeur (mm)',
    defaultValue: MIN_WIDTH,
    nextStepData: largeur,
    nextStep: false,
    notIncludeDescription: true,

    validation: (value) => {
        return value > 0;
    },
};

// const AxeManuel = {
//     id: 'VR-TR-AXE-API',
//     type: formInputsTypes?.SELECT_INPUT,
//     label: 'Sélectionner un axe',
//     name: 'axe',
//     nextStepData: widthAxe,
//     nextStep: false,
//     options: axeData
// }
export default AxeManuel;
